export default {
  done: 'Done',
  addSite: 'Add a Site',
  clinicsList: 'Clinics List',
  notes: 'Notes',
};
